import { PRICING_MODELS, REVENUE_RECOGNITION_TYPE, USAGE_PRICING_MODELS } from '@vy/types';
import type { RevenueRecognitionType } from './types';

const usagePricingModels = new Set<string>(Object.values(USAGE_PRICING_MODELS));

export function getDefaultRevenueRecognitionType(
  pricingModel: string | null | undefined,
  revenueMonthCount: number,
): RevenueRecognitionType {
  if (pricingModel && usagePricingModels.has(pricingModel)) {
    return REVENUE_RECOGNITION_TYPE.UsageBased;
  }

  if (revenueMonthCount === 1) {
    return REVENUE_RECOGNITION_TYPE.PointInTime;
  }

  if (!pricingModel) {
    return REVENUE_RECOGNITION_TYPE.StraightLine;
  }

  if (pricingModel === PRICING_MODELS.Subscription || pricingModel === PRICING_MODELS.CommercialTerms) {
    return REVENUE_RECOGNITION_TYPE.StraightLine;
  }

  if (pricingModel === PRICING_MODELS.FixedOneTime) {
    return REVENUE_RECOGNITION_TYPE.PointInTime;
  }

  return REVENUE_RECOGNITION_TYPE.StraightLine;
}
